module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }